import BaseController from './BaseController';

import VisualReportDataSource from '../dataSources/VisualReportDataSource';
import UserInfoDataSource from '../dataSources/UserInfoDataSource';

class VisualReportsController extends BaseController {
    static get name() {
        return 'VisualReportsController';
    }

    static getInstance(options) {
        return new VisualReportsController(options);
    }

    onActivate() {
        this.bindGluBusEvents({
            VISUAL_REPORTS_LOAD_REQUEST: this.onVisualReportsLoadRequest,
            VISUAL_REPORTS_GET_REQUEST: this.onVisualReportsGetRequest,
            VISUAL_REPORT_SAVE_REQUEST: this.onVisualReportSaveRequest,
            VISUAL_REPORT_UPDATE_REQUEST: this.onVisualReportUpdateRequest,
            VISUAL_REPORT_UPDATE_LOCAL_REQUEST: this.onVisualReportUpdateLocalRequest,
            VISUAL_REPORT_DELETE_REQUEST: this.onVisualReportDeleteRequest,
            VISUAL_REPORTS_FROM_ACTIVE_LIST_GET_REQUEST: this.onGetVisualReportsFromActiveList,
        });

        this.visualReportDataSource = this.activateSource(VisualReportDataSource);
        this.userInfoDataSource = this.activateSource(UserInfoDataSource);
    }

    onVisualReportsLoadRequest = () => {
        this.visualReportDataSource.loadVisualReportsHydrated().then(visualReports => {
            this.bus.emit('VISUAL_REPORTS_LOAD_SUCCESS', { visualReports });
        });
    };

    onVisualReportsGetRequest = ({ source }) => {
        this.bus.emit('VISUAL_REPORTS', {
            visualReports: this.visualReportDataSource.visualReports,
            source,
        });
    };

    /**
     * @param {object} param0
     * @param {import('../types').VisualReport} param0.visualReport
     */
    onVisualReportSaveRequest = ({ visualReport }) => {
        this.visualReportDataSource.saveVisualReport(visualReport);
        this.bus.emit('VISUAL_REPORT_SAVE_SUCCESS', {
            visualReports: this.visualReportDataSource.visualReports,
            newReport: visualReport,
            showEditPopup: false,
        });
        this.bus.emit('VISUAL_REPORTS_FROM_ACTIVE_LIST_GET_REQUEST');
        this.bus.emit('DEAL_LISTS_LOAD_REQUEST');
    };

    /**
     * @param {object} param0
     * @param {string} param0.title
     * @param {number} param0.reportId
     * @param {number[]} param0.selection
     * @param {string} param0.profile
     * @param {number} param0.listId
     * @param {string} param0.status
     * @param {string} param0.notes
     * @param {string} [param0.polygon] a custom shape's ring, when `profile` is `polygon`
     */
    onVisualReportUpdateRequest = ({
        title,
        reportId,
        selection,
        status,
        notes,
        profile,
        listId,
        polygon,
    }) => {
        this.visualReportDataSource
            .updateVisualReport({
                title,
                reportId,
                selection,
                profile,
                listId,
                status,
                notes,
                polygon,
            })
            .then(
                visualReport => {
                    this.bus.emit('VISUAL_REPORT_UPDATE_SUCCESS', {
                        visualReports: this.visualReportDataSource.visualReports,
                        newReport: visualReport,
                    });
                    this.bus.emit('VISUAL_REPORTS_FROM_ACTIVE_LIST_GET_REQUEST');
                    this.bus.emit('DEAL_LISTS_LOAD_REQUEST');
                },
                error => {
                    this.bus.emit('VISUAL_REPORT_UPDATE_FAILED', {
                        error: error,
                    });
                },
            );
    };

    /**
     * @param {object} param0
     * @param {import('../types').VisualReport} param0.visualReport
     */
    onVisualReportUpdateLocalRequest = ({ visualReport }) => {
        this.visualReportDataSource.updateLocalVisualReport({
            visualReport,
        });
        this.bus.emit('VISUAL_REPORT_UPDATE_SUCCESS', {
            visualReports: this.visualReportDataSource.visualReports,
            newReport: visualReport,
        });
        this.bus.emit('VISUAL_REPORTS_FROM_ACTIVE_LIST_GET_REQUEST');
        this.bus.emit('DEAL_LISTS_LOAD_REQUEST');
    };

    /**
     * @param {number} reportId
     */
    onVisualReportDeleteRequest = reportId => {
        this.visualReportDataSource.deleteVisualReport(reportId).then(
            () => {
                this.bus.emit('VISUAL_REPORT_DELETE_SUCCESS', {
                    visualReports: this.visualReportDataSource.loadVisualReportsHydrated(),
                    showEditPopup: false,
                    reportId,
                });
            },
            error => console.error(error),
        );
    };

    onGetVisualReportsFromActiveList() {
        const { myDealsActiveList } = this.userInfoDataSource.userPreferences;

        const visualReports = myDealsActiveList
            ? this.visualReportDataSource.visualReports.filter(
                  vr => vr.listId === myDealsActiveList.id,
              )
            : [];

        this.bus.emit('VISUAL_REPORTS_FROM_ACTIVE_LIST', {
            visualReports,
        });
    }

    onDeactivate() {
        this.unbindGluBusEvents();
    }
}

export default VisualReportsController;
